import type { CSSProperties } from 'react'
import { COLORS, FONT, SPACING, RADIUS } from '../ui/tokens'
import type { PeerState, RTCStatus } from '../../lib/webrtc'

const STATUS_COLOR: Record<RTCStatus, string> = {
  idle: COLORS.textDisabled, connecting: COLORS.warning, connected: COLORS.success, failed: COLORS.error, closed: COLORS.textDisabled,
}
const STATUS_LABEL: Record<RTCStatus, string> = {
  idle: 'Ожидание', connecting: 'Подключение', connected: 'Связь', failed: 'Ошибка', closed: 'Отключён',
}

export function PeerList({ peers }: { peers: PeerState[] }) {
  if (peers.length === 0) {
    return <div style={{ padding: `${SPACING.md}px`, textAlign: 'center', color: COLORS.textDisabled, fontSize: FONT.sm }}>Вы одни в канале</div>
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {peers.map((peer) => <PeerRow key={peer.userId} peer={peer} />)}
    </div>
  )
}

function PeerRow({ peer }: { peer: PeerState }) {
  const rowStyle: CSSProperties = {
    display: 'flex', alignItems: 'center', gap: SPACING.sm, padding: `${SPACING.sm}px ${SPACING.md}px`,
    backgroundColor: peer.speaking ? COLORS.error + '18' : 'transparent', borderRadius: RADIUS.md, transition: 'background-color 0.15s',
  }
  return (
    <div style={rowStyle}>
      <div style={{ width: 32, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {peer.speaking ? <SpeakingWave /> : <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: STATUS_COLOR[peer.status] }} />}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: FONT.sm, color: COLORS.textPrimary, fontWeight: peer.speaking ? 600 : 400 }}>{peer.userId.slice(0, 8)}…</div>
        <div style={{ fontSize: FONT.xs, color: STATUS_COLOR[peer.status] }}>{peer.speaking ? 'Говорит...' : STATUS_LABEL[peer.status]}</div>
      </div>
      {peer.speaking && <span style={{ fontSize: 18 }}>🔊</span>}
    </div>
  )
}

function SpeakingWave() {
  const barStyle = (delay: string, height: number): CSSProperties => ({
    width: 3, height, borderRadius: 2, backgroundColor: COLORS.error, animation: `wave 0.8s ease-in-out infinite`, animationDelay: delay,
  })
  return (
    <>
      <style>{`@keyframes wave { 0%, 100% { transform: scaleY(0.4); } 50% { transform: scaleY(1.0); } }`}</style>
      <div style={{ display: 'flex', alignItems: 'center', gap: 2, height: 20 }}>
        <div style={barStyle('0s', 12)} /><div style={barStyle('0.15s', 18)} /><div style={barStyle('0.3s', 14)} />
        <div style={barStyle('0.15s', 20)} /><div style={barStyle('0s', 10)} />
      </div>
    </>
  )
}
